module.exports = __webpack_public_path__ + "static/media/wen.9f403e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wen.png
// module id = 117
// module chunks = 1 8